export type AdPopcornAction = 'openOfferwall' | 'closeOfferwall' | 'getRewardInfo' | 'setUserId';

type AdPopcornMessage = { action: AdPopcornAction } & Record<string, unknown>;

export function postToAdPopcorn(
  action: AdPopcornAction,
  data: Record<string, unknown> = {}
): boolean {
  const message: AdPopcornMessage = { action, ...data };

  // iOS (WebKit)
  if (window.webkit?.messageHandlers?.AdPopcornRewardJsBridge) {
    window.webkit.messageHandlers.AdPopcornRewardJsBridge.postMessage(message);
    return true;
  }

  // Android (WebView) - JSON string 필수
  if (window.AdPopcornRewardJsBridge?.postMessage) {
    window.AdPopcornRewardJsBridge.postMessage(JSON.stringify(message));
    return true;
  }

  return false;
}
